import { render, staticRenderFns } from "./app-review-tile.vue?vue&type=template&id=b93a3ff2"
import script from "./app-review-tile.js?vue&type=script&lang=js&external"
export * from "./app-review-tile.js?vue&type=script&lang=js&external"
import style0 from "./app-review-tile.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports